"use client";

import React, { useEffect, useState } from "react";
import { Quote, ShieldCheck } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "Marcus Sterling",
  quote: "Lake Stone Enterprise didn't just fix my credit; they architected a financial foundation that allowed me to scale my real estate portfolio by $2M in six months.",
  position: "Real Estate Developer"
}, {
  author: "Elena Rodriguez",
  quote: "The business consulting and funding strategies provided were elite. We secured the capital we deserved and optimized our management flow instantly.",
  position: "Tech Startup Founder"
}];
export default function VoicesOfSecurity() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  return <section data-section-id="223164" id="success-stories" className="bg-background py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center opacity-[0.05]">
        <div className="w-[800px] h-[800px] rounded-lg bg-primary blur-3xl mix-blend-screen" />
      </div>

      <div ref={ref} className={cn("container mx-auto px-4 md:px-6 relative z-10 max-w-4xl transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-default font-bold tracking-tighter text-foreground mb-4 uppercase">
            Success Stories
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-default">
            Elite results for high-performance entrepreneurs. See how we scale personal and business capital.
          </p>
        </div>

        <div className="relative bg-card/60 backdrop-blur-xl shadow-2xl shadow-primary/10 border border-primary/20 rounded-2xl p-8 md:p-16">
          <Carousel setApi={setApi} opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, index) => <CarouselItem key={index} data-index={index}>
                  <div className="flex flex-col items-center text-center space-y-8">
                    <Quote className="size-16 text-primary/40 rotate-180" />
                    
                    <blockquote className="text-xl md:text-3xl font-serif italic text-foreground leading-relaxed max-w-3xl">
                      "{testimonial.quote}"
                    </blockquote>
                    
                    <div className="flex flex-col items-center space-y-3 pt-4">
                      <div className="space-y-1">
                        <div className="font-default font-semibold text-lg text-foreground tracking-tight">
                          {testimonial.author}
                        </div>
                        <div className="text-sm text-muted-foreground font-default uppercase tracking-widest">
                          {testimonial.position}
                        </div>
                      </div>
                      
                      <Badge variant="secondary" className="mt-2 text-primary bg-primary/10 hover:bg-primary/20 border-primary/30 transition-colors rounded-md">
                        <ShieldCheck className="size-3.5 mr-1" />
                        Verified Success Partner
                      </Badge>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>

          {}
          <div className="flex justify-center gap-3 mt-12">
            {Array.from({
            length: count
          }).map((_, i) => <button key={i} data-index={i} className={cn("h-2 rounded-md transition-all duration-300 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring", current === i + 1 ? "w-8 bg-primary shadow-[0_0_10px_rgba(16,185,129,0.5)]" : "w-2 bg-primary/20 hover:bg-primary/40")} onClick={() => api?.scrollTo(i)} aria-label={`Go to slide ${i + 1}`} />)}
          </div>
        </div>
      </div>
    </section>;
}